/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KoreaOutboundImage
 */
export interface KoreaOutboundImage {
    /**
     * 图片URL
     * @type {string}
     * @memberof KoreaOutboundImage
     */
    imgUrl?: string;
    /**
     * 文件id
     * @type {number}
     * @memberof KoreaOutboundImage
     */
    orderFileId?: number;
}

/**
 * Check if a given object implements the KoreaOutboundImage interface.
 */
export function instanceOfKoreaOutboundImage(value: object): value is KoreaOutboundImage {
    return true;
}

export function KoreaOutboundImageFromJSON(json: any): KoreaOutboundImage {
    return KoreaOutboundImageFromJSONTyped(json, false);
}

export function KoreaOutboundImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): KoreaOutboundImage {
    if (json == null) {
        return json;
    }
    return {
        
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'orderFileId': json['orderFileId'] == null ? undefined : json['orderFileId'],
    };
}

export function KoreaOutboundImageToJSON(json: any): KoreaOutboundImage {
    return KoreaOutboundImageToJSONTyped(json, false);
}

export function KoreaOutboundImageToJSONTyped(value?: KoreaOutboundImage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'imgUrl': value['imgUrl'],
        'orderFileId': value['orderFileId'],
    };
}

